import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-panel',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './panel.component.html',
})
export class PanelComponent {}
